<template>
  <div id="cancelTaskModal" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="p-4">
          <h2>{{ this.modalText.header }}</h2>
          <div class="mb-3">{{ modalText.body }}</div>
          <span class="font-size-125">{{ modalText.subBody }}</span>
        </div>
        <div class="modal-footer">
          <button class="btn close-btn" @click.prevent="close">
            <i class="fa fa-times mr-1"></i><strong>{{ modalText.leftBtnText }}</strong>
          </button>
          <button id="cancleJobBtn" class="btn btn-danger" @click="cancelJob" v-if="modalText.rightBtnText">
            <i class="far fa-trash-alt"></i><strong> {{ modalText.rightBtnText }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {EventBus} from '../../events/event.bus';
import { useResultPageStore } from '../../stores/ResultPageStore';
import {EVENT_JOB_CANCEL_INIT, EVENT_JOB_CANCEL} from "../../events/job.events";
import { JOB_STATE_CANCELLED } from '../../const/job.const';
import {ApiConfig, createSatApi} from "../../../../../../../lib-sat/api/api"
import {getValueFromCurrentUrl} from "../../../../../../helper/query-fragment-params"
import { translate } from '../../../../../../helper/translate';

export default {
  name: 'CancelTaskModal',
  props: {},
  components: {},
  data() {
    return {
      confirmDeleteText:{
        header: translate('Cancel Task'),
        body: translate('Are you sure you want to cancel this task?'),
        subBody: translate('The processing will be stopped immediately, and no Credits will be deducted.'),
        leftBtnText: translate('No'),
        rightBtnText: translate('Yes')
      },
      jobCompletedText:{
        header: translate('Great news!'),
        body: translate('Your task has been completed in the meantime.'),
        subBody: translate('You can close this modal now and see the finalized results of your task.'),
        leftBtnText: translate('Close'),
        rightBtnText: null,
      },
      rateLimitText:{
        header: translate('Rate Limit'),
        body: translate("You've attempted to cancel tasks too frequently."),
        subBody: translate('Please wait before trying again.'),
        leftBtnText: translate('Close'),
        rightBtnText: null,
      },
      modalText: null,
      jobId: null,
    };
  },
  mounted: function () {
    this.store = useResultPageStore();

    $('#cancelTaskModal').modal({show: false});
  },
  created: function () {
    this.modalText = this.confirmDeleteText
    
    EventBus.$on(EVENT_JOB_CANCEL_INIT, (id) => {
      this.jobId = id;
      $('#cancelTaskModal').modal('show');
    });
  },
  methods: {
    close() {
      $('#cancelTaskModal').modal('hide');
      //Reset the text to default
      this.modalText = this.confirmDeleteText
    },
    async cancelJob() {
      const apiConfig = new ApiConfig();
      const satApi = createSatApi(apiConfig);
      const cancelJobId = getValueFromCurrentUrl('j') || this.jobId;

      // we get currentJob this way because 
      // CancelTaskModal no longer under Result page scope
      const jobs = this.store.getJobs();
      this.currentJob = jobs.filter(job => {
        if (job?.apiJob?.id === cancelJobId) return job;
      })[0];

      satApi.cancelJob(cancelJobId)
          .done(()=>{
            EventBus.$emit(EVENT_JOB_CANCEL, {});

            if (this.currentJob?.state) {
              this.currentJob.state = JOB_STATE_CANCELLED;
            }
             
            this.close()
          })
          .fail( (apiError, message) => {
            const error = JSON.parse(message)
            if(error.message === 'Job already finished'){
              this.modalText = this.jobCompletedText
            }else{
              this.modalText = this.rateLimitText
            }
          })
    },

  },
  computed: {},
};
</script>
<style lang="scss" scoped>
#cancelTaskModal {
  img {
    width: 100%;
    height: auto;
  }

  .modal-dialog {
    width: 599px;
    max-width: 95%;
    border-radius: 9px;
    overflow: hidden;
  }

  .close-btn {
    background: #d9d9d9;
    height: 38px;
    gap: 10px;
    padding: 0 10px 0 10px;
    font-weight: 600;
  }

  .premium-btn {
    background-color: #ffaa00;
    height: 38px;
    gap: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
    padding: 0 10px 0 10px;
  }

  .modal-content-title {
    font-size: 28px;
    font-weight: 600;
  }

  .modal-content {
    h2 {
      margin-top: 0;
    }

    font-size: 17.5px;
    border: 1px solid #ccc;

    p {
      font-size: 17.5px;
    }
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    display: flex;
    padding: 10px 10px;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background: #f8f9fa;

    .btn {
      margin: 0;
    }
  }
}
</style>
